import classNames from 'classnames'

import type { TextProps } from '@/shared/components/typography/Title'

import { levels, colors, weights, styles } from '@/styles/shared/typography'

const Tint = ({ level, color, weight, children, style, className }: TextProps) => {
  return (
    <span
      className={classNames(
        levels[level],
        color ? colors[color] : '',
        weight ? weights[weight] : '',
        style ? styles[style] : '',
        className
      )}
    >
      {children}
    </span>
  )
}

export default Tint
